<template>
	<div @click.stop style="cursor: default;">
		<div class="flexcenter" style="justify-content: space-between;height:30px;">

			<b>{{ this.product.name}}</b>
			<Icon v-if="this.productSpinner" fileName="w3_spinner_grey" class="spinner"
				style="width:20px;height:20px;margin-right:5px;margin-top:0px;" />
		</div>

		<!-- vanlig produkt -->
		<div v-if="!this.hasProductOptions">

			<div style="">
				
				<!-- pris-->
				<div class="flexcenter" style="flex-direction: column;align-items: start;flex-grow:1;">
					<b style="font-size: min(20px, calc(1.2vw + 13px));"
						:class="this.isOutlet(this.productId) ? 'outlet-price' : ''">{{
						this.formatPrice(this.product) }}</b>

					<div v-if="this.isLoggedIn && this.displayPrice && this.product?.details?.productOptionCount == 0"
						style="margin-top:5px;flex-direction: column;align-items: start;width:100%;" class="flexcenter">

						<div class="flexcenter" style="">

							<div v-if="this.product?.details?.discountModel?.success" class="discountBadge link"
								@click.stop="this.showDiscountInformation = !this.showDiscountInformation"
								style="font-size:90%;margin-right:5px;">{{
								this.product?.details?.discountModel?.label }}</div>

							<div style="color:grey;font-weight: bold;">
								{{ this.formatPrice1(this.product?.details?.price1) }}
							</div>

						</div>




					</div>

				</div>
			</div>

			<div class="flexcenter" style="margin-top:10px;">

				<b>Antal</b>
				<div class="form textField" style="max-width:60px;margin-left:5px;" title="Antal">
					<input type="text" placeholder="Antal" v-model="this.quantity"
						style="padding:1px;padding-left:5px;" />
					<img src="@/assets/w3_button_close_light.png" @click="this.quantity = 1">
				</div>

				<div class="link" @click="this.buy();" style="background: var(--bg-message);padding:5px;border-radius: 5px;margin-left:5px;"><b
						style="color:white;padding-left:10px;padding-right:10px;">KÖP</b></div>
			</div>

			<div
				v-if="this.isLoggedIn && !this.hasProductOptions && showDiscountInformation && this.product?.details?.discountModel && this.product?.details?.discountModel?.success"
				style="margin-top:10px;">
				<DiscountModelView :discountModel="this.product?.details?.discountModel" />
			</div>

		</div>

		<!-- produkt med options -->
		<div v-if="this.hasProductOptions">
			<b>Produktvarianter</b>

			<ProductOptionList :productOptionModel="this.productOptionModel"
				@buyProductOption="((productOptionSet) => this.buyProductOption(productOptionSet))" style="margin-top:5px;"
				:dropshipActive="false" />

		</div>
	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";
import { productMixin } from "@/mixins/productMixin.js";
import { userMixin } from "@/mixins/userMixin.js";
import ProductOptionList from "./ProductOptionList.vue";
import { USER_STORE_ACTION, USER_STORE_GETTER } from "../../../store/user-store";
import DiscountModelView from "./DiscountModelView.vue";

export default {
	name: "BuyButtonWrapper",
	components: { ProductOptionList, DiscountModelView },
	mixins: [productMixin, userMixin],
	props: {
		productId: Number,
	},
	data() {
		return {
			productSpinner: false,
			showDiscountInformation: false,
			quantity: 1,
		};
	},
	computed: {

		product() {

			if (this.productId > 0) {
				return this.$store.state.productStore.data.productList[this.productId]
			}

			return null;

		},

		productOptionModel() {



			// gå igenom listan med productOptionSet och filtrera fram vilka vi ska ha med. 

			var model = { headerList: [], rowList: [] };

			// loopa igenom 

			this.product?.details?.productOptionSetList?.filter(productOptionSet => productOptionSet != null).sort((a, b) => a.sort - b.sort).forEach(productOptionSet => {

				const row = {};
				row.productOptionSet = productOptionSet

				var colMap = new Map;

				productOptionSet?.productOptionList?.filter(productOption => productOption != null).sort((a, b) => a.productOptionTypeId - b.productOptionTypeId).forEach(productOption => {
					const productOptionTypeId = productOption.productOptionTypeId;

					// om den ska finnas med eller flyttas till egenskaper
					//if (!this.productOptionTypeIdListWithOneValue.includes(productOptionTypeId)) {
						model.headerList[productOptionTypeId] = { productOptionTypeId: productOptionTypeId, typeValue: productOption.typeValue, typeWeb: productOption.typeWeb } // FP: Om index redan finns så skrivs det över

						colMap.set(productOptionTypeId, productOption);
					//}

				})
				row.colMap = colMap




				model.rowList.push(row)
			})

			model.headerList = model.headerList.filter(header => header !== null); // rensar bort null värden. 

			console.log('FP: productOption: model: ', model);

			return model;



		},

		hasProductOptions() {
			return this.product?.productOptionData?.count > 0
		},

		displayPrice() {
			return this.$store.getters[USER_STORE_GETTER.DISPLAY_PRICE1];
		},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		buy() {
			this.productSpinner = true;
			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, quantity: this.quantity } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data }).finally(() => { 
				this.productSpinner = false
				this.$emit('close')
			});
		},

		buyProductOption(productOptionSet) {
			this.productSpinner = true;
			const productOptionSetId = productOptionSet.productOptionSetId;
			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, productOptionSetId: productOptionSetId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data }).finally(() => { 
				this.productSpinner = false;
				this.$emit('close')
			});
		},



	},
	created() {
		//if (!this.product?.productDetails){
			this.getProductDetails({ productId: this.productId });
		//}
	}
};
</script>

<style scoped>

div.discountBadge {
	background: var(--bg-discount);
	color: white;
	font-weight: bold;
	border-radius: 3px;
	padding: 3px;
	padding-left: 5px;
	padding-right: 5px;
	font-size: 80%;


}
</style>